<template>
  <v-row no-gutters>
    <v-col class="pa-0">
      <NormalNumberInput width="100%" v-model="inputedValue.min" />
    </v-col>
    <v-col class="originalCenter" cols="1"> ～ </v-col>
    <v-col>
      <NormalNumberInput width="100%" v-model="inputedValue.max" />
    </v-col>
  </v-row>
</template>

<script>
import NormalNumberInput from '@/components/items/inputs/NormalNumberInput'

export default {
  components: {
    NormalNumberInput
  },
  props: {
    value: {
      type: Object,
      require: false,
      default: () => ({
        start: '',
        end: ''
      })
    }
  },
  data: () => ({
    items: [],
    start: '',
    end: ''
  }),
  created() {
    //
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style scoped lang="scss"></style>
